import { Typography } from "@mui/material";
import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <Typography className="Typography foot">Copyright &copy; 2023 - Instagram Clone</Typography>
    </footer>
  );
};

export default Footer;
